var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3197 11.9317L19.1964 7.2837C19.0331 7.08161 18.831 7 18.5901 7H8.80835C8.36531 7 8 7.36531 8 7.80835V25.1917C8 25.6347 8.36531 26 8.80835 26H22.7173C23.1604 26 23.4868 25.6347 23.5257 25.2305V12.4602C23.5218 12.2581 23.4441 12.0949 23.3197 11.9317ZM19.3596 9.8603L20.9413 11.6519H19.3596V9.8603ZM21.9051 24.4261H9.61669V8.57783H17.7818V12.4175C17.7818 12.8605 18.1471 13.2258 18.5901 13.2258H21.9051V24.4261Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5559 16.1367C11.5559 16.5797 11.9212 16.9451 12.3643 16.9451H19.1575C19.6005 16.9451 19.9658 16.5797 19.9658 16.1367C19.9658 15.6937 19.6005 15.3284 19.1575 15.3284H12.3643C11.9212 15.3284 11.5559 15.6937 11.5559 16.1367Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1575 20.3416H12.3643C11.9213 20.3416 11.556 20.7069 11.556 21.1499C11.556 21.5929 11.9213 21.9582 12.3643 21.9582H19.1575C19.6006 21.9582 19.9659 21.5929 19.9659 21.1499C19.9659 20.7069 19.6006 20.3416 19.1575 20.3416Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesFour);
export default __webpack_public_path__ + "static/media/features-four.f4f70a0c.svg";
export { ForwardRef as ReactComponent };